










































































import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import { Vue, Component } from 'vue-property-decorator'

import { PEER_GRANT } from '@/store/share/constants'
import { State, Getter, Action } from 'vuex-class'
import { RootState } from '@/store/types'
import { UserWithKey } from '@/types/user'
import { Permission, Grant } from '@/store/share/types'

/**
 * Component to share the entry to a new user
 */
@Component({ components: { Multiselect }, name: 'share-add-peer' })
export default class ShareAddPeer extends Vue {
    /**
     * All users in the organisation
     */
    @State((state: RootState) => state.share.users)
    users!: UserWithKey[]

    /**
     * All users with access to the current entry
     */
    @State((state: RootState) => state.share.peers)
    peers!: UserWithKey[]

    /**
     * Permissions that the current user can assign other users
     */
    @Getter
    assignablePermissions!: Permission[]

    /**
     * Share to a user
     */
    @Action(PEER_GRANT)
    grantPermission!: (grant: Grant) => Promise<boolean>

    /**
     * New peer
     */
    peer: UserWithKey | null = null

    /**
     * New permission
     */
    permission: Permission | null = null

    /**
     * Options for new user dropdown
     * Gets the list of users who do not already
     * have access
     */
    get options(): UserWithKey[] {
        return _.differenceBy(this.users, this.peers, 'id')
    }

    get valid(): boolean {
        return this.peer !== null && this.permission !== null
    }

    /**
     * Dispatch a PEER_GRANT action in the store, and
     * clear local data on success
     * TODO: Show errors
     */
    async grant(): Promise<void> {
        if (!this.valid) {
            this.$error({ text: 'You need to specify a user and permission' })
            return
        }
        const success = await this.grantPermission({
            peer: this.peer!,
            permission: this.permission!.name
        })
        if (success) {
            this.peer = null
            this.permission = null
            this.$success({
                text: 'Shared successfully'
            })
        }
    }
}
